import { PipeTransform, Pipe } from '@angular/core';
import { Utils } from '../services/utils.service';

@Pipe({name: 'phoneNumber'})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private utils: Utils) {
  }

  transform(value: string): string {
    let mask: string = '–';

    if (value !== null && typeof value !== 'undefined' && value !== '') {
      mask = this.utils.formatPhoneNumber(value);
    }

    return mask;
  }
}
